//存健康数据
export const GET_WEST_LIST_DATA = "get_west_list_data";
//请求健康数据
export const REQ_WEST_LIST_DATA = "req_west_list_data";
